// === NAV

let navToggleBtn = document.querySelector(".js-nav-toggle");
let navCloseBtn = document.querySelector(".js-nav-close");
var navMain = document.querySelector(".nav-main");
let navLinks = navMain.querySelectorAll(".nav-main-list__link");

navToggleBtn.addEventListener("click", function () {
	toggleNav();
	this.classList.toggle("nav-is-open");
});

navCloseBtn.addEventListener("click", function () {
	toggleNav();
	navToggleBtn.classList.toggle("nav-is-open");
});

document.body.addEventListener('keydown', function(e) {
    if (navMain.classList.contains("is-open")) {
        toggleNav();
    }
})

function toggleNav() {
	navMain.classList.toggle("is-open");

	if (navMain.classList.contains("is-open")) {
		// Remove (the negative) tabindex
		for (let i = 0; i < navLinks.length; i++) {
			navLinks[i].removeAttribute("tabindex");
		}
	} else {
		// Put the negative tabindex back
		for (let i = 0; i < navLinks.length; i++) {
			navLinks[i].tabIndex = -1;
		}
	}
	// Adds overlay and sets body to fixed
	document.body.classList.toggle("nav-is-open");
}
